import prepareComponent from "@bluframe/grapple/prepareComponent"
import React, { ChangeEventHandler, type Ref, useId, useState } from "react"

import Checkbox from "./Checkbox"

export type OptionValue = number | string

export interface Props {
  defaultIsChecked?: boolean
  inputId?: string
  isChecked?: boolean
  label: React.ReactNode
  name: string

  onChange?: (value: OptionValue) => void
  ref?: Ref<HTMLInputElement>
  value?: OptionValue
}

export interface ComponentProps extends Omit<Props, "onChange"> {
  inputId: string
  internalIsChecked?: boolean
  isControlled: boolean
  labelId: string
  onChange: ChangeEventHandler<HTMLInputElement>
}

const usePrepareComponent = (props: Props): ComponentProps => {
  // Internal state for selected value
  const [internalIsChecked, setInternalIsChecked] = useState<
    boolean | undefined
  >(props.defaultIsChecked)

  const generatedId = useId()
  const inputId = props.inputId ?? generatedId

  const labelId = `${inputId}-label`

  // Determine if the component is controlled
  const isControlled = props.value !== undefined

  const onChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    event.stopPropagation()

    if (isControlled && props.value) {
      props.onChange?.(props.value)
    }

    if (!isControlled) {
      setInternalIsChecked(event.target.checked)
    }
  }

  return {
    ...props,
    inputId,
    internalIsChecked,
    isControlled,
    labelId,
    onChange
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent)(
  Checkbox
)
